import {
  FETCH_FIELDS,
  FETCH_FIELD,
  CREATE_FIELD,
  UPDATE_FIELD,
  DELETE_FIELD,
  ADD_FIELD,
  ADD_FIELDS,
  REMOVE_FIELD,
  CLEAR_FIELDS,
} from 'constants';

export const fetchFields = entity => ({type : FETCH_FIELDS, payload : {entity}});
export const fetchField = id => ({type : FETCH_FIELD, payload : {id}});
export const createField = field => ({type : CREATE_FIELD, payload : {field}});
export const updateField = field => ({type : UPDATE_FIELD, payload : {field}});
export const deleteField = field => ({type : DELETE_FIELD, payload : {field}});
export const addField = field => ({type : ADD_FIELD, payload : {field}});
export const addFields = fields => ({type : ADD_FIELDS, payload : {fields}});
export const removeField = field => ({type : REMOVE_FIELD, payload : {field}});
export const clearFields = entity => ({type : CLEAR_FIELDS, payload : {entity}});



// WEBPACK FOOTER //
// ./src/common/actions/fields.js